export default __webpack_public_path__ + "static/media/homedialysis03.6bdf6b0e.png";